class RouteHelper {
    static getProgramStatsUrl(programId) {
        return `/programs/${programId}/stats`;
    }
}

export default RouteHelper;